import React, { PropsWithChildren } from "react";
import styled from "styled-components";

const Styled = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: 0;
  box-sizing: border-box;
`;
const Main = styled.div`
  box-sizing: border-box;
  flex: 1;
  min-height: 0;
  height: 100%;
  overflow: auto;
`;

// interface VFlexProps extends React.FC<StyledCommonProps> {
//   Main: typeof Main;
// }
/**
 * Full height container that allows one or more panels (divs) to flex to its
 * maximum possible height. */
const VFlex: any = (props: PropsWithChildren<any>) => {
  return <Styled className={props.className}>{props.children}</Styled>;
};

VFlex.Main = Main;

export default VFlex;
